// // src/components/Issues/IssueFilters.js
// import React from 'react';
// import {
//   Card,
//   CardHeader,
//   CardContent,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Button,
//   Collapse,
// } from '@mui/material';

// const IssueFilters = ({
//   showFilters,
//   filters,
//   sort,
//   usersList,
//   statusOptions,
//   onFilterChange,
//   onSortChange,
//   onClearFilters,
// }) => {
//   return (
//     <Collapse in={showFilters}>
//       <Card sx={{ mb: 3 }}>
//         <CardHeader
//           title="Filters & Sorting"
//           action={
//             <Button onClick={onClearFilters} color="primary">
//               Clear All
//             </Button>
//           }
//         />
//         <CardContent>
//           <Grid container spacing={3}>
//             {/* Issue Title Filter */}
//             <Grid item xs={12} md={3}>
//               <TextField
//                 fullWidth
//                 label="Issue Title"
//                 value={filters.title}
//                 onChange={(e) => onFilterChange('title', e.target.value)}
//               />
//             </Grid>

//             {/* Status Filter */}
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Status</InputLabel>
//                 <Select
//                   value={filters.status_id}
//                   onChange={(e) => onFilterChange('status_id', e.target.value)}
//                   label="Status"
//                 >
//                   <MenuItem value="">All Statuses</MenuItem>
//                   {statusOptions.map((status) => (
//                     <MenuItem key={status.id} value={status.id}>
//                       {status.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Created By Filter */}
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Created By</InputLabel>
//                 <Select
//                   value={filters.author_id}
//                   onChange={(e) => onFilterChange('author_id', e.target.value)}
//                   label="Created By"
//                 >
//                   <MenuItem value="">All Users</MenuItem>
//                   {usersList.map((user) => (
//                     <MenuItem key={user.id} value={user.id}>
//                       {user.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Model Type Filter */}
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Model Type</InputLabel>
//                 <Select
//                   value={filters.model_type}
//                   onChange={(e) => onFilterChange('model_type', e.target.value)}
//                   label="Model Type"
//                 >
//                   <MenuItem value="">All Types</MenuItem>
//                   <MenuItem value="Lead">Lead</MenuItem>
//                   {/* Add other model types as needed */}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Sort Options */}
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Sort By</InputLabel>
//                 <Select
//                   value={sort.sort_by}
//                   onChange={(e) => onSortChange({ ...sort, sort_by: e.target.value })}
//                   label="Sort By"
//                 >
//                   <MenuItem value="created_at">Created Date</MenuItem>
//                   <MenuItem value="title">Issue Title</MenuItem>
//                   <MenuItem value="updated_at">Last Updated</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Sort Direction</InputLabel>
//                 <Select
//                   value={sort.sort_direction}
//                   onChange={(e) => onSortChange({ ...sort, sort_direction: e.target.value })}
//                   label="Sort Direction"
//                 >
//                   <MenuItem value="desc">Descending</MenuItem>
//                   <MenuItem value="asc">Ascending</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>
//     </Collapse>
//   );
// };

// export default IssueFilters;

import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Collapse,
  Autocomplete,
  Select,
  MenuItem
} from '@mui/material';

const IssueFilters = ({
  showFilters,
  filters,
  sort,
  usersList,
  statusOptions,
  onFilterChange,
  onSortChange,
  onClearFilters,
}) => {
  return (
    <Collapse in={showFilters}>
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Filters & Sorting"
          action={
            <Button onClick={onClearFilters} color="primary">
              Clear All
            </Button>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            {/* Issue Title Filter */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Issue Title"
                value={filters.title}
                onChange={(e) => onFilterChange('title', e.target.value)}
              />
            </Grid>

            {/* Status Filter */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status_id}
                  onChange={(e) => onFilterChange('status_id', e.target.value)}
                  label="Status"
                >
                  <MenuItem value="">All Statuses</MenuItem>
                  {statusOptions.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Created By Filter with Autocomplete */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <Autocomplete
                  value={filters.author_id ? usersList.find(user => user.id === filters.author_id) : null}
                  onChange={(e, value) => onFilterChange('author_id', value ? value.id : '')}
                  options={usersList}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} label="Created By" />}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  disableClearable
                  noOptionsText="No author found"
                />
              </FormControl>
            </Grid>

            {/* Model Type Filter */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Model Type</InputLabel>
                <Select
                  value={filters.model_type}
                  onChange={(e) => onFilterChange('model_type', e.target.value)}
                  label="Model Type"
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="Lead">Lead</MenuItem>
                  {/* Add other model types as needed */}
                </Select>
              </FormControl>
            </Grid>

            {/* Sort Options */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sort.sort_by}
                  onChange={(e) => onSortChange({ ...sort, sort_by: e.target.value })}
                  label="Sort By"
                >
                  <MenuItem value="created_at">Created Date</MenuItem>
                  <MenuItem value="title">Issue Title</MenuItem>
                  <MenuItem value="updated_at">Last Updated</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort Direction</InputLabel>
                <Select
                  value={sort.sort_direction}
                  onChange={(e) => onSortChange({ ...sort, sort_direction: e.target.value })}
                  label="Sort Direction"
                >
                  <MenuItem value="desc">Descending</MenuItem>
                  <MenuItem value="asc">Ascending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Collapse>
  );
};

export default IssueFilters;
